/* oxlint-disable react/static-components -- these render APIs intentionally receive component references */
import { Link } from 'react-router-dom'

const PRIVACY_POLICY_URL = `https://app.termly.io/policy-viewer/policy.html?policyUUID=84ed68d7-d676-472c-9974-d35b3a4861a5`
const TERMS_OF_SERVICE_URL = `https://app.termly.io/policy-viewer/policy.html?policyUUID=de7d508f-ec3f-468c-96d8-bbdb2eed61e4`

export function PasswordRules({ password }: { password: string }) {
  const hasUppercase = /[A-Z]/.test(password)
  const hasSpecial = /[^A-Za-z0-9]/.test(password)
  const hasNumber = /[0-9]/.test(password)
  const hasMinLength = password.length >= 8

  // oxlint-disable-next-line react/no-unstable-nested-components -- render helper intentionally captures parent state
  const Rule = ({ met, label }: { met: boolean; label: string }) => (
    <div className="flex items-center gap-2">
      <div className={`h-2 w-2 rounded-full ${met ? `bg-green-500` : `bg-(--line-strong)`}`} />
      <span className={`text-sm ${met ? `text-subtle` : `text-minimal`}`}>{label}</span>
    </div>
  )

  return (
    <div className="col-span-6 mb-4 grid grid-cols-2 gap-x-8 gap-y-2">
      <Rule met={hasUppercase} label="One uppercase character" />
      <Rule met={hasSpecial} label="One special character" />
      <Rule met={hasNumber} label="One number" />
      <Rule met={hasMinLength} label="8 characters minimum" />
    </div>
  )
}

export function TermsFooter() {
  return (
    <div className="text-sm text-default">
      <p className="col-span-6 my-10 text-center">
        By signing up for a Trackable account you are agreeing to the{` `}
        <a href={PRIVACY_POLICY_URL} className="font-bold text-blue-600 no-underline">
          Privacy Policy
        </a>
        {` `}
        and{` `}
        <a href={TERMS_OF_SERVICE_URL} className="font-bold text-blue-600 no-underline">
          Terms of Service
        </a>
        .
      </p>
      <p className="text-center">
        Already have an account?{` `}
        <Link to="/login" className="font-bold text-blue-600 underline">
          Sign in
        </Link>
      </p>
    </div>
  )
}
